import React, { useState, useEffect, useRef } from "react";
import { isUndefined, size, map } from "lodash";
import ApiEngine from "../../util/ApiEngine";
import { useForm, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  ApiKey, ApiUrl, SessionKey, WebUrl, LanguageOption, PhoneNumberPrefix
} from "../../util/Constant";
import {
  stringIsNullOrEmpty, createFormBody, numberWithCommas, numberWithCurrencyFormat2, isObjectEmpty, createMultiPartFormBody } from "../../util/Util";
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import {
  setActiveTab,
  setBusy,
  setDownlineQuery,
  setDownlineSearchText,
  setIdle,
  setPageSize,
  setY,
  showResponseMessage,
  setDisplayProfile
} from "../../redux/AppAction";
import { useDispatch, useSelector } from "react-redux";
import ToggleButton from "react-toggle-button";
import { numberWithCurrencyFormat } from "../../util/Util.js";
import Spinner from "../custom/BootstrapSpinner";
import { useHistory } from "react-router-dom";

const ProfileDetail = (props) => {
  const { t, i18n } = useTranslation();
  const _history = useHistory();
  const _dispatch = useDispatch();
  const [member, setMember] = useState({});
  const [memberFullName, setMemberFullName] = useState("");
  const [userName, setUsername] = useState("");
  const [vipName, setVipName] = useState("");
  const [formattedEmail, setFormattedEmail] = useState("");
  const [formattedPhone, setFormattedPhone] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [isShareholder, setIsShareholder] = useState(false);
  const [checkVipPinExist, setCheckVipPinExist] = useState(true);
  const [isPhoneVerify, setIsPhoneVerify] = useState(false);
  const [TACphoneNumber, setTACphoneNumber] = useState("");
  const [sentCode, setSentCode] = useState(false);
  const [countdownPeriod, setCountdownPeriod] = useState(0);
  const [selectedPhonePrefix, setSelectedPhonePrefix] = useState("");
  const _COUNTDOWN_PERIOD = 120;
  const _SECONDS_IN_MS = 1000;
  const [enteredCode, setEnteredCode] = useState("");
  const [toggleActive, setToggleActive] = useState(false);

  const [showFormattedPhone, setshowFormattedPhone] = useState("");
  const {
    errors: resetPhoneErrors,
    handleSubmit: handleResetPasswordSubmit,
    watch: resetPhoneWatch,
    setValue: setPhoneValue,
    setError: setPhoneError,
    clearErrors: clearPhoneErrors,
    register: phoneRegister,
  } = useForm();
  const {
    register: profileRegister,
    errors: profileErrors,
    handleSubmit: handleProfileSubmit,
    setValue: setProfileValue,
    getValues: getProfileValues,
    clearErrors: clearProfileErrors,
    watch: profileWatch,
  } = useForm();
  const [walletList, setWalletList] = useState([]);
  const [loadingWalletData, setLoadingWalletData] = useState(true);
  const [loadingWalletData1, setLoadingWalletData1] = useState(true);
  const _userData = useSelector((state) => state.authState.userData);
  let isPlatinum = useSelector((state) => state.appState.isPlatinum);
  const [isGoldHover, setIsGoldHover] = useState(false);
  const [isPlatinumHover, setIsPlatinumHover] = useState(false);
  const [isPartnerHover, setIsPartnerHover] = useState(false);

  useEffect(() => {
    init();
    getWalletData();
  }, []);

  async function init() {
    let params = {};
    var responseJson = await ApiEngine.get(ApiUrl._API_GET_MEMBER_DETAILS_BY_ID);
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      setIsShareholder(responseJson[ApiKey._API_DATA_KEY]["isShareHolder"]);
      setMember(responseJson[ApiKey._API_DATA_KEY]);
      setMemberFullName(responseJson[ApiKey._API_DATA_KEY]["userFullName"]);
      setUsername(responseJson[ApiKey._API_DATA_KEY]["username"]);
      setVipName(responseJson[ApiKey._API_DATA_KEY]["vipName"]);
      setFormattedEmail(responseJson[ApiKey._API_DATA_KEY]["email"]);
      setFormattedPhone(responseJson[ApiKey._API_DATA_KEY]["phoneNumber"]);
      var tempPhoneNumber = responseJson[ApiKey._API_DATA_KEY]["phoneNumber"];
      setSelectedPhonePrefix(
        PhoneNumberPrefix.filter((prefix) =>
          tempPhoneNumber.includes(prefix.value)
        ).length > 0
          ? PhoneNumberPrefix.filter((prefix) =>
            tempPhoneNumber.includes(prefix.value)
          )[0].value
          : PhoneNumberPrefix[0].value
      );
      const phone = responseJson[ApiKey._API_DATA_KEY]?.phoneNumber || "";
      const matchedPrefix =
        PhoneNumberPrefix.find((x) => tempPhoneNumber.includes(x.value)) ||
        { value: "" }; // fallback if no match

      const prefixLength = matchedPrefix.value.length;

      setshowFormattedPhone(
        phone.substring(prefixLength, phone.length)
      );

      //setReferralCode(responseJson[ApiKey._API_DATA_KEY]["referralCode"]);
      setBirthDate(responseJson[ApiKey._API_DATA_KEY]["birthDateString"]);
      setIsPhoneVerify(responseJson[ApiKey._API_DATA_KEY]["isPhoneVerify"]);
      getFirstReferralCode();

    }
    setLoadingWalletData1(false);
  }

  const sendVerificationCode = async () => {
    await ApiEngine.post(
      ApiUrl._API_SEND_VERIFICATION_CODE,
      createMultiPartFormBody({ phoneNumber: selectedPhonePrefix + showFormattedPhone })
    ).then((response) => {
      if (response[ApiKey._API_SUCCESS_KEY]) {
        let tempTACphoneNumber = response[ApiKey._API_DATA_KEY];
        setTACphoneNumber(tempTACphoneNumber);
        setSentCode(true);
        setCountdownPeriod(_COUNTDOWN_PERIOD);
      }
    });
  };

  useEffect(() => {
    if (countdownPeriod > 0) {
      setTimeout(() => {
        let tempPeriod = countdownPeriod - 1;
        setCountdownPeriod(tempPeriod);
      }, _SECONDS_IN_MS);
    } else {
      setSentCode(false);
    }
  }, [countdownPeriod]);

  const submitProfileForm = async (data, e) => {
    e.preventDefault();
    _dispatch(setBusy());

    if (!isPhoneVerify) {
      {
        let verifyJson = await ApiEngine.post(
          ApiUrl._API_VERIFY_PHONE_NUMBER,
          createMultiPartFormBody({
            verificationCode: data.profileVerifyCode,
            phoneNumber: selectedPhonePrefix + showFormattedPhone
          })
        );
        if (verifyJson[ApiKey._API_SUCCESS_KEY]) {
          submitPhoneNumber();

          _dispatch(
            showResponseMessage(
              verifyJson[ApiKey._API_SUCCESS_KEY],
              verifyJson[ApiKey._API_MESSAGE_KEY]
            )
          );
        } else {
          _dispatch(
            showResponseMessage(
              verifyJson[ApiKey._API_SUCCESS_KEY],
              verifyJson[ApiKey._API_MESSAGE_KEY]
            )
          );
        }
      }
    }
    setSentCode(false);
    _dispatch(setIdle());
  };

  async function submitPhoneNumber() {
    // let params = {
    //   phoneNumber: formattedPhone
    // };

    let data = [];

    data["phoneNumber"] = selectedPhonePrefix + showFormattedPhone;
    data["isMemberOperate"] = true;

    var responseJson = await ApiEngine.post(
      ApiUrl._API_UPDATE_MEMBER_PHONE_NUMBER,
      createMultiPartFormBody(data)
    );

    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      _dispatch(
        showResponseMessage(
          responseJson[ApiKey._API_SUCCESS_KEY],
          responseJson[ApiKey._API_MESSAGE_KEY]
        )
      );
    }

    if (!responseJson[ApiKey._API_SUCCESS_KEY]) {
      _dispatch(
        showResponseMessage(false, responseJson[ApiKey._API_MESSAGE_KEY])
      );
    }
    init();
  }

  const getWalletData = async () => {
    let walletJson = await ApiEngine.get(ApiUrl._API_GET_NON_SEAMLESS_PRODUCT_BALANCE);
    if (walletJson[ApiKey._API_SUCCESS_KEY]) {
      let data = walletJson[ApiKey._API_DATA_KEY];
      setWalletList(data);
    }
    setLoadingWalletData(false);
  }

  const handleCloseProfileModal = () => {
    _dispatch(setDisplayProfile(false));
  }

  const getFirstReferralCode = async () => {
    let referralCode = await ApiEngine.get(ApiUrl._API_GET_FIRST_REFERRAL_CODE_BY_MEMBER_ID);
    if (referralCode[ApiKey._API_SUCCESS_KEY]) {
      let data = referralCode[ApiKey._API_DATA_KEY];
      setReferralCode(data);
    }
  }

  return (
    <>
      {!loadingWalletData1 && !loadingWalletData ?
        <>
          <div className="custom-container-box-my-profile">
            <div className="profile-details-container-ug">
              <div className="first">
                <div style={{ padding:'30px 0px 0px'}}>
                  <div className="progress-bar">
                    <div className="progress-fill" style={{ width: _userData.isVip ? "100%" : isPlatinum ? "66.666%" : "33.333%" }} />
                  </div>
                  <div className="level-markers">
                    {/* Gold Level */}
                    <div className="level-marker gold">
                      <span style={{ color: "#FDBE2F", fontSize: '12px' }}>{t("GOLD_1")}</span>
                      <div className="">
                        <img style={{ height:'30px' }} src="/img/ug/status_icon/gold.svg" alt="balance" />
                      </div>
                    </div>
                    {/* Platinum Level */}
                    <div className="level-marker platinum">
                      <span style={{ color: "#D6E9FF", fontSize: '12px' }}>{t("PLATINUM")}</span>
                      <div className="">
                        <img style={{ height: '30px' }} src="/img/ug/status_icon/platinum.svg" alt="balance"/>
                      </div>
                    </div>

                    {/* Partner Level */}
                    <div className="level-marker partner">
                      <span style={{ color: "#51A0FF", fontSize: '12px' }}>{t("PARTNER")}</span>
                      <div className="">
                        <img style={{ height: '30px' }} src="/img/ug/status_icon/partner.svg" alt="balance" />
                      </div>
                    </div>

                  </div>
                  <div style={{ margin: "-30px 0px 20px", fontSize:"12px" }}>
                    {isGoldHover ? t("HOVER_GOLD") : isPlatinumHover ? t("HOVER_PLATIUM") : isPartnerHover ? t("HOVER_PARTNER") : (_userData.isVip ? t("TARGET_PARTNER") : isPlatinum ? t("TARGET_PLATINUM") : t("TARGET_GOLD"))}
                  </div>
                </div>
                <div className="profile-details-item">
                  <div>
                    {t("CURRENT_LEVEL")} :
                  </div>
                  <div className="profile-details-username" style={{
                    color: _userData.isVip ? "#51A0FF" : isPlatinum ? "#D6E9FF" : "#FDBE2F"
                  }}>
                    {_userData.isVip ? t("PARTNER") : isPlatinum ? t("PLATINUM") : t("GOLD_1")}
                  </div>
                </div>
                <div className="profile-details-item">
                  <div>
                    {t("USERNAME")} :
                  </div>
                  <div className="profile-details-username">
                    <img
                      src={_userData.isVip ? "/img/ug/status_icon/partner.png" : isPlatinum ? "/img/ug/status_icon/platinum.png" : "/img/ug/status_icon/gold.png"}
                      className="img-responsive"
                      alt="status icon"
                    />
                    {userName}
                  </div>
                </div>
                <div className="profile-details-item">
                  <div>
                    {t("FULLNAME")} :
                  </div>
                  <div>
                    {memberFullName}
                  </div>
                </div>
                <div className="profile-details-item">
                  <div>
                    {t("EMAIL")} :
                  </div>
                  <div>
                    {formattedEmail}
                  </div>
                </div>
              </div>
              <div className="second">
                <div className="profile-details-item">
                  <div>
                    {t("PHONE_NUMBER")} :
                  </div>
                  <div className="with-phone-input">
                    <select
                      className="phone-number-prefix-ug custom-input-style-1 width-auto-global-ug"
                      onChange={(e) => setSelectedPhonePrefix(e.target.value)}
                      disabled={isPhoneVerify ? true : false}
                      value={selectedPhonePrefix}
                    >
                      {PhoneNumberPrefix.map((prefix, index) => {
                        return (
                          <option
                            key={index}
                            className={"phone-prefix-" + (index + 1)}
                            value={prefix.value}
                          >
                            {prefix.label}
                          </option>
                        );
                      })}
                    </select>
                    <input
                      type="number"
                      name="verfityPhone"
                      className="custom-input-style-phone-1"
                      style={{ maxWidth: '140px' }}
                      disabled={isPhoneVerify ? true : false}
                      placeholder="Phone Number"
                      autoComplete="off"
                      ref={phoneRegister({
                        required: "REQUIRED_NEW_PHONE_NUMBER",
                      })}
                      value={showFormattedPhone}
                      onChange={(e) => setshowFormattedPhone(e.target.value)}
                      errors={resetPhoneErrors}
                    />
                    {isPhoneVerify ?
                      <div className="image-1">
                        <img
                          src={"/img/v3/verified.png"}
                          className="img-responsive"
                          alt="pm"
                        />
                      </div>
                      :
                      <div
                        className="image-1"
                        onClick={() => sendVerificationCode()}
                      >
                        <div className="send-code cursor-global">Send Code</div>
                      </div>}
                  </div>
                </div>
                <div className="profile-details-item">
                  <div>
                    {t("REFERRAL_CODE")} :
                  </div>
                  <div style={{ display: 'flex' }}>
                    {referralCode ?
                      <>
                        <div>
                          {referralCode}
                        </div>
                        <div style={{ color: '#FDBE2F', paddingLeft: '5px' }} onClick={() => { handleCloseProfileModal(); _history.push(WebUrl._URL_REFERRAL_CODE_UG) }}>
                          {t("VIEW_MORE")}
                        </div>
                      </>
                      :
                      <div className="profile-details-rc-new" onClick={() => { handleCloseProfileModal(); _history.push(WebUrl._URL_REFERRAL_CODE_UG) }}>
                        <div className="profile-referral-code-div">
                          <img
                            src={"/img/ug/transaction/yellow-warning.svg"}
                            className="img-responsive"
                            alt="pm"
                          />
                          {t("UNVERIFIED")}
                        </div>
                        <div>
                          {t("CLICK_ACTIVATE_REFERRAL_CODE")}
                        </div>
                      </div>
                    }
                  </div>
                </div>
                <div className="profile-details-item">
                  <div>
                    {t("BIRTHDATE")} :
                  </div>
                  <div>
                    {birthDate}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="custom-container-box-my-profile mb-4">
            <h3 className="mt-4 pt-2">{t("WALLET_INFO")}</h3>
            {walletList &&
              walletList.length &&
              map(walletList, (item, index) => {
                return (
                  <div key={index} className="wallet-info-items">
                    <div className="wallet">
                      {item.productName === "Main Wallet" ? t("MAIN_WALLET") : item.productName}{" :"}
                    </div>
                    <div className={numberWithCurrencyFormat(parseFloat(item.balance), 2, true) > 0 ? "amount positive" : "amount"}>
                      {numberWithCurrencyFormat(parseFloat(item.balance), 2, true)}
                    </div>
                  </div>
                );
              })
            }
          </div>
        </>

        :
        <div style={{ textAlign: "center" }} className="mt-4">
          <Spinner animation="border" role="status"></Spinner>
        </div>

      }
      <Modal
        isOpen={sentCode}
        id="profile-modal"
        wrapClassName="settings-modal"
        centered
      >
        <ModalHeader>
          <div className="modal-header-wrapper">
            <h3>{t("VERIFICATION_CODE")}</h3>
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="col-12">
            {sentCode && (
              <form onSubmit={handleProfileSubmit(submitProfileForm)}>
                <div className="register-tac-wrapper">
                  <input
                    type="number"
                    name="profileVerifyCode"
                    className="register-tac custom-input-style-1"
                    style={{ width:'100%' }}
                    placeholder={t("ENTER_VERIFICATION_CODE")}
                    autoComplete="off"
                    ref={profileRegister({
                      // required: true,
                      required: "FIELD_REQUIRED",
                      pattern: {
                        value: /^[0-9]+$/,
                        message: "INVALID_VERIFICATION_CODE",
                      },
                    })}
                    errors={profileErrors}
                    onChange={(e) => setEnteredCode(e.target.value)}
                  />

                  {sentCode && countdownPeriod != 0 && (
                    <p className="tac-countdown">
                      {t("VERIFICATION_CODE_SENT")} {t("VALID_FOR")}{" "}
                      {countdownPeriod}s
                    </p>
                  )}

                  <div className={"invalid-feedback"}></div>
                </div>
                <div>
                  <button type="submit" className="btn btn-block btn-submit-ug">{t("SUBMIT")} </button>
                </div>
              </form>
            )}
          </div>

        </ModalBody>
      </Modal>
    </>
  );
};
export default ProfileDetail;
